import React from 'react';

export function CameraOn() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-video">
      <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
      <rect x="2" y="6" width="14" height="12" rx="2" />
    </svg>
  );
}

export function CameraOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#D00700"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-video-off">
      <path d="M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196" />
      <path d="M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" />
      <path d="m2 2 20 20" />
    </svg>
  );
}

export function MicrophoneOn() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-mic">
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" x2="12" y1="19" y2="22" />
    </svg>
  );
}

export function MicrophoneOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#D00700"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-mic-off">
      <line x1="2" x2="22" y1="2" y2="22" />
      <path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" />
      <path d="M5 10v2a7 7 0 0 0 12 5" />
      <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" />
      <path d="M9 9v3a3 3 0 0 0 5.12 2.12" />
      <line x1="12" x2="12" y1="19" y2="22" />
    </svg>
  );
}

export function Screenshare() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-screen-share">
      <path d="M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" />
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="m17 8 5-5" />
      <path d="M17 3h5v5" />
    </svg>
  );
}

export function ScreenshareOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#D00700"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-screen-share">
      <path d="M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" />
      <path d="M8 21h8" />
      <path d="M12 17v4" />
      <path d="m17 8 5-5" />
      <path d="M17 3h5v5" />
    </svg>
  );
}

export function Leave() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#D00700"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-log-out">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" x2="9" y1="12" y2="12" />
    </svg>
  );
}

export function Info() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25Z"
        stroke="#121A24"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0055 9C12.5519 9 13 8.56069 13 8.00578C13 7.43931 12.5519 7 12.0055 7C11.4481 7 11 7.43931 11 8.00578C11 8.56069 11.4481 9 12.0055 9Z"
        fill="#121A24"
      />
      <path
        d="M12 11V16"
        stroke="#121A24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-message-circle">
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </svg>
  );
}

export function ChatHighlighted() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Arrow() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM19 12L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L19 12ZM14.5303 6.46967C14.2374 6.17678 13.7626 6.17678 13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033L14.5303 6.46967ZM13.4697 16.4697C13.1768 16.7626 13.1768 17.2374 13.4697 17.5303C13.7626 17.8232 14.2374 17.8232 14.5303 17.5303L13.4697 16.4697ZM5 12.75H19V11.25H5V12.75ZM19.5303 11.4697L14.5303 6.46967L13.4697 7.53033L18.4697 12.5303L19.5303 11.4697ZM18.4697 11.4697L13.4697 16.4697L14.5303 17.5303L19.5303 12.5303L18.4697 11.4697Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TeacherViewScreens() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-layout-grid">
      <rect width="7" height="7" x="3" y="3" rx="1" />
      <rect width="7" height="7" x="14" y="3" rx="1" />
      <rect width="7" height="7" x="14" y="14" rx="1" />
      <rect width="7" height="7" x="3" y="14" rx="1" />
    </svg>
  );
}

export function ParticipantsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-users">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function DefaultParticipantIcon() {
  return (
    <svg width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#2E2E38" />
      <path
        d="M18 24C18 24.5523 17.5523 25 17 25C16.4477 25 16 24.5523 16 24C16 23.4477 16.4477 23 17 23C17.5523 23 18 23.4477 18 24Z"
        fill="white"
      />
      <path
        d="M24 24C24 24.5523 23.5523 25 23 25C22.4477 25 22 24.5523 22 24C22 23.4477 22.4477 23 23 23C23.5523 23 24 23.4477 24 24Z"
        fill="white"
      />
      <path
        d="M18.6219 26.5C18.0023 26.5 17.5 27.0023 17.5 27.6218C17.5 27.9273 17.6246 28.2196 17.8449 28.4311L18.071 28.6481C18.4801 29.0409 18.9792 29.2846 19.5 29.3792V30.5C19.5 30.7761 19.7239 31 20 31C20.2761 31 20.5 30.7761 20.5 30.5V29.3792C21.0208 29.2846 21.5199 29.0409 21.929 28.6481L22.1551 28.4311C22.3754 28.2196 22.5 27.9273 22.5 27.6218C22.5 27.0023 21.9977 26.5 21.3782 26.5H18.6219Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3846 6.18338C20.2932 6.07084 20.1576 6.00396 20.0133 6.00017C19.869 5.99638 19.7302 6.05607 19.633 6.16366L17.4225 8.61269L15.666 7.56932C15.4355 7.43238 15.1386 7.50416 14.995 7.73158L13.8876 9.48437H10.568C10.3134 9.48437 10.1001 9.67829 10.0741 9.93334L9.76273 12.9903L7.32926 14.2136C7.13593 14.3108 7.02722 14.5228 7.06043 14.7379L7.50162 17.5946L6.17525 19.7353C6.06682 19.9103 6.07624 20.1344 6.19894 20.2996L6.2003 20.3014L6.20741 20.3112C6.214 20.3203 6.2242 20.3345 6.23747 20.3534C6.26402 20.3911 6.30273 20.4474 6.34931 20.5185C6.44285 20.6614 6.56625 20.8614 6.6864 21.0906C6.94097 21.576 7.12514 22.0892 7.09458 22.4585C7.08957 22.519 7.05514 22.6506 6.96989 22.8713C6.88942 23.0798 6.78287 23.3208 6.6649 23.5873L6.65701 23.6051C6.46959 24.0285 6.25359 24.5165 6.1247 24.9462C6.05936 25.164 6.00729 25.3954 6.0007 25.6142C5.99431 25.8262 6.02872 26.1024 6.22036 26.3264C6.30601 26.4265 6.42753 26.4884 6.55835 26.4985L9.1333 26.698L8.36387 28.8291C8.30652 28.988 8.33272 29.1652 8.4335 29.3003C8.53429 29.4354 8.69602 29.5101 8.86344 29.4989L11.8889 29.2957C12.6663 32.0269 15.1621 34 18.0926 34H21.9082C24.7783 34 27.2314 32.1074 28.0616 29.4636L30.5279 30.2279C30.6855 30.2767 30.8568 30.2436 30.9852 30.1395C31.1136 30.0354 31.1823 29.8739 31.1686 29.7085L30.9565 27.1449L33.5104 26.5822C33.6151 26.5591 33.7096 26.5026 33.7798 26.4209C33.982 26.1856 34.008 25.8879 33.9983 25.6716C33.9879 25.4414 33.9316 25.193 33.8612 24.9556C33.7217 24.4851 33.4931 23.9509 33.3003 23.5004L33.2936 23.4846C33.1826 23.2252 33.0843 22.9952 33.0115 22.8032C32.9753 22.7077 32.9481 22.6287 32.9298 22.5655C32.9208 22.5343 32.9148 22.5099 32.911 22.4916C32.9075 22.4746 32.9068 22.4669 32.9068 22.4669C32.8823 22.091 33.0698 21.5735 33.322 21.0885C33.4414 20.8589 33.5634 20.6587 33.6557 20.5157C33.7017 20.4445 33.7399 20.3882 33.7661 20.3504L33.7817 20.328L33.7957 20.3081L33.8027 20.2984L33.804 20.2966C33.9245 20.1316 33.9332 19.9091 33.8255 19.7353L32.4992 17.5946L32.9403 14.7379C32.9736 14.5228 32.8648 14.3108 32.6715 14.2136L30.2379 12.9902L29.9266 9.94873C29.9006 9.69461 29.6886 9.50111 29.4349 9.50001L26.1139 9.48555L25.0058 7.73158C24.867 7.51188 24.584 7.43626 24.3553 7.55777L22.3616 8.61707L20.3846 6.18338ZM15.2118 20.7324C16.5061 19.6525 18.172 19 20 19C21.828 19 23.4939 19.6525 24.7882 20.7324L25.3451 21.197L25.5813 20.5113C25.7842 19.9221 26.3434 19.5 27 19.5C27.8284 19.5 28.5 20.1716 28.5 21C28.5 21.7825 27.9004 22.4256 27.136 22.4939L26.4131 22.5586L26.731 23.211C27.2778 24.3329 27.5514 25.6092 27.4669 26.9518L27.4106 27.8456C27.2281 30.7432 24.8248 33 21.9215 33H18.0785C15.1752 33 12.7719 30.7432 12.5894 27.8456L12.5331 26.9518C12.4486 25.6092 12.7222 24.3329 13.269 23.211L13.5869 22.5586L12.864 22.4939C12.0996 22.4256 11.5 21.7825 11.5 21C11.5 20.1716 12.1716 19.5 13 19.5C13.6566 19.5 14.2158 19.9221 14.4187 20.5113L14.6549 21.197L15.2118 20.7324Z"
        fill="white"
      />
    </svg>
  );
}

export function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-x">
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}

export function ParticipantCameras() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-square-arrow-out-up-left">
      <path d="M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6" />
      <path d="m3 3 9 9" />
      <path d="M3 9V3h6" />
    </svg>
  );
}

export function ExpandArrows() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-expand">
      <path d="m15 15 6 6" />
      <path d="m15 9 6-6" />
      <path d="M21 16.2V21h-4.8" />
      <path d="M21 7.8V3h-4.8" />
      <path d="M3 16.2V21h4.8" />
      <path d="m3 21 6-6" />
      <path d="M3 7.8V3h4.8" />
      <path d="M9 9 3 3" />
    </svg>
  );
}
